import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { marcarOnboardingCompleto } from '../../actions/auth';

export const SuscripcionExitosa = () => {
    const dispatch = useDispatch();
    const { hashtag } = useSelector(state => state.auth);
    const [cargando, setCargando] = useState(false);
    console.log('SuscripcionExitosa hashtag:', hashtag, 'cargando:', cargando);
    

    const handleIrANegocio = async () => {
        if (!hashtag) return;
        window.location.href = 'https://revi.la/app';
    };

    return (
        <div className="app-container" style={{ position: 'relative' }}>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '32px 24px' }}>
                <div style={{ width: 72, height: 72, borderRadius: '50%', background: 'var(--pink-100)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 34, marginBottom: 16 }}>
                    🎉
                </div>
                <h1 style={{ fontSize: 22, fontWeight: 700, color: 'var(--pink-900)', marginBottom: 8, textAlign: 'center' }}>
                    ¡Suscripción activada!
                </h1>
                <p style={{ fontSize: 14, color: 'var(--pink-800)', lineHeight: 1.7, marginBottom: 24, textAlign: 'center' }}>
                    Tu periodo de prueba de 30 días ha comenzado. No se hará ningún cobro hasta que termine.
                </p>
                <button
                    className="btn-primary"
                    style={{ width: '100%' }}
                    onClick={handleIrANegocio}
                    disabled={cargando || !hashtag}
                >
                    {!hashtag ? 'Cargando sesión...' : cargando ? 'Cargando...' : 'Ir a mi negocio →'}
                </button>
            </div>
        </div>
    );
};
